__turbopack_context__.v({
  "container": "E8rcmG_container",
  "content": "E8rcmG_content",
  "cta": "E8rcmG_cta",
  "gutterContent": "E8rcmG_gutterContent",
  "heading": "E8rcmG_heading",
  "headingContainer": "E8rcmG_headingContainer",
  "image": "E8rcmG_image",
  "leftContent": "E8rcmG_leftContent",
  "rightContent": "E8rcmG_rightContent",
  "subheading": "E8rcmG_subheading",
});
